export default "__VITE_ASSET__w3EgHU15__"